<ul class="footer-mobile">
  <li class="footer-mobile__item footer-mobile__logo-box">
    <mflooring-logo-footer class="footer-mobile__logo" [content]="logoContent"
    [presentation]="logoPresentation"></mflooring-logo-footer>
  </li>

  <li class="footer-mobile__item footer-mobile__menu submenu-mobile">
    <mflooring-expansion-menu-mobile [items]="menu?.siteMenuItems" [page]="page">
    </mflooring-expansion-menu-mobile>
  </li>

  <li class="footer-mobile__item">
    <h3>SUBSCRIBE TO OUR EMAIL</h3>
    <!-- <div *ngIf="isMobile" id="hubspotForm" class="footer-hub-form"></div> -->
    <!-- Custom Hubspot Form -->
    <mflooring-custom-hubspot-form
      [portalId]="hubspotData?.['mf.hubspot.portalId']"
      [formId]="hubspotData?.['mf.hubspot.footer.formId']"
    ></mflooring-custom-hubspot-form>
    <!-- <div>
    <mflooring-footer-input-text
      label="FIND A RETAILER"
      placeholder="Enter Zip Code"
      [footerData]="footerData"
      [id]="'zip-code-mobile'"
    ></mflooring-footer-input-text>
  </div> -->
</li>
<li class="footer-mobile__item">
  <ul class="footer-mobile__social__menu" role="menu">
    @for (icon of socialIcons; track trackBy($index, icon)) {
      <li role="menuitem">
        <a class="footer__social-links__item theme-{{ theme }}" rel="noopener, noreferrer" captureClicks
          data-link-type="social" [attr.aria-label]="icon.name" [href]="icon?.url"
          [attr?.data-link-name]="icon.name">
					<mflooring-icon-button [presentation]="{
							size: 'small',
							type: '',
							iconName: icon?.name,
							iconUrl: icon?.imgUrl
						}" class="main-header-search--icon"></mflooring-icon-button>
        </a>
      </li>
    }
  </ul>
</li>
</ul>